import Vue from 'vue';
import OrderModal from 'components/modals/order';
import { itemForGroup } from 'lib/order-helpers';
import { kebabCase } from 'lodash';
import axios from 'lib/axios';

const order = {
  state: {
    menu: [],
    timeSlots: null,
    selectedTimeSlot: null,
    initiated: false,
    completed: null,
    settings: {
     timeslotLimit: 6,
     openingHours: null,
     openForOrders: false
    }
  },

  mutations: {
    setMenu: (state, data) => {
      state.menu = data;
    },

    setCompleted: (state, data) => {
      state.completed = data && Object.values(data).length ? data[0] : null;
    },

    updateBasket: (state, { id, quantity }) => {
      const item = state.menu.map(g => g.items).flat(2).find(i => i.id === id);
      Vue.set(item, 'quantity', quantity);
    },

    clearBasket: (state) => {
      state.menu.map(g => g.items).flat(2).forEach(item => {
        Vue.set(item, 'quantity', 0);
      });
    },

    setTimeSlots: (state, data) => {
      state.timeSlots = data;
    },

    setSelectedTimeSlot: (state, slot) => {
      state.selectedTimeSlot = slot;
    },

    setSettings: (state, settings) => {
      for (const setting of settings) {
        Vue.set(state.settings, setting.key, setting.data);
      }
    }
  },

  actions: {
    loadMenu: ({ commit }) => {
      try {
        const { data } = window.prismicData.results.find((document) => document.type === 'menu');
        const menuItems = window.prismicData.results.filter((document) => document.type === 'menu_item');

        const menu = data.body.map(group => {
          return {
            title: group.primary.type,
            items: group.items.filter(i => i.menu_item && i.menu_item.id).map(item => itemForGroup(menuItems, item, group.primary.type))
          };
        });

        commit('setMenu', menu);
      } catch (e) {
        console.log(e);
      }
    },

    loadTimeSlots: async ({ commit, state }, data = null) => {
      try {
        if (!data) {
          const response = await axios.get('timeslots');
          data = response.data;
        }

        commit('setTimeSlots', data.timeslots);
        let available;

        try {
          available = data.timeslots.map(t => t.id).includes(state.selectedTimeSlot);
        } catch (e) {
          console.log(e);
          available = false;
        }

        if (!state.completed && state.selectedTimeSlot && !available) {
          commit('setSelectedTimeSlot', null);
        }
      } catch (e) {
        console.log(e);
      }
    },

    loadSettings: async ({ commit, state }) => {
      try {
        const { data } = await axios.get('settings');
        commit('setSettings', data);
      } catch (e) {
        console.log(e);
      }
    },

    updateBasket: ({ commit, state, getters, dispatch }, params) => {
      const { id, action } = params;
      const item = state.menu.map(g => g.items).flat(2).find(i => i.id === id);
      let quantity = item.quantity || 0;

      if (action === 'add' && getters.pizzaCount >= state.settings.timeslotLimit && item.type === 'pizza') {
        dispatch('modal/openModal', { component: OrderModal, data: { error: 'max-pizzas' } }, { root: true });
        return;
      }

      if (action === 'add' && quantity < 10) {
        quantity++;
      }

      if (action === 'remove' && quantity > 0) {
        quantity--;
      }

      commit('setSelectedTimeSlot', null);
      commit('updateBasket', { id, quantity });
    }
  },

  getters: {
    basket: (state, getters) => {
      return state.menu.map(g => g.items).flat(2).filter(i => i.quantity);
    },

    hasProductsInBasket: (state, getters) => {
      return getters.basket.length > 0;
    },

    basketTotal: (state, getters) => {
      return getters.basket.reduce((sum, item) => sum + item.price * item.quantity, 0);
    },

    orderTotal: (state) => {
      return state.completed.items.reduce((sum, item) => sum + item.price * item.quantity, 0);
    },

    pizzaCount: (state, getters, items) => {
      try {
        const pizzaIds = state.menu.find(i => kebabCase(i.title) === 'pizza').items.map(i => i.id);
        const pizzas = getters.basket.filter(i => pizzaIds.includes(i.id));
        return pizzas.reduce((sum, item) => sum + item.quantity, 0);
      } catch (e) {
        return null;
      }
    },

    filteredTimeSlots: (state, getters) => {
      return state.timeSlots ? state.timeSlots.filter(t => t.available >= getters.pizzaCount) : null;
    },

    isOpenForOrders: (state, getters) => {
      return state.settings.openForOrders;
    }
  }
};

export default order;
